import createStore from "astrid-helpers/src/createStore";
export const [getAmp, setAmp, useAmp] = createStore(1);
//# sourceMappingURL=amp.js.map